<template>
    <div  class="mpro wow">
        <div class="title wow fadeInUp" @click="gotomPro">
            产品中心
        </div>
        <div class="allItems  wow fadeInUp">
        <div class="item" v-for="(item,index) in list" :key="index">
            <div class="one" @click="gotoPro(item.id)">
                <div>
                    <img :src="item.img" alt="">
                </div>
                <p>{{item.name}}</p>
            </div>
            <div class="two" @click="gotoPro(item.id)">
                    <img :src="item.img2" alt="">
                <p>{{item.name}}</p>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
    import {getClass} from '../util/lang'
    export default {
        name: "mpro",
        data(){
          return{
              list:[
                  {
                      img:require('../assets/zr/sf1.png'),
                      img2:require('../assets/zr/sf2.png'),
                      name:'沙发'
                  },
                  {
                      img:require('../assets/zr/cj1.png'),
                      img2:require('../assets/zr/cj2.png'),
                      name:'茶几'
                  },
                  {
                      img:require('../assets/zr/tg1.png'),
                      img2:require('../assets/zr/tg2.png'),
                      name:'厅柜'
                  },
                  {
                      img:require('../assets/zr/bg1.png'),
                      img2:require('../assets/zr/bg2.png'),
                      name:'边柜'
                  },
                  {
                      img:require('../assets/zr/c1.png'),
                      img2:require('../assets/zr/c2.png'),
                      name:'床'
                  },
                  {
                      img:require('../assets/zr/ws1.png'),
                      img2:require('../assets/zr/ws2.png'),
                      name:'卧室柜'
                  },
                  {
                      img:require('../assets/zr/cz1.png'),
                      img2:require('../assets/zr/cz2.png'),
                      name:'餐桌'
                  },
                  {
                      img:require('../assets/zr/yz1.png'),
                      img2:require('../assets/zr/yz2.png'),
                      name:'椅子'
                  },
                  {
                      img:require('../assets/zr/sg1.png'),
                      img2:require('../assets/zr/sg2.png'),
                      name:'书柜'
                  }
              ]
          }
        },
        mounted(){
            this.$nextTick(()=>{
                this.getList('2')
            })
        },
        methods:{
            gotomPro(){
                const link='/pro.html'
                window.open(link,'_self')
            },
            gotoPro(id){
                const link=`/pro.html?id=${id}`
                window.open(link,'_self')
            },
            getList(id){
                const url = `${getClass(id)}`
                this.$axios.get(url).then(res => {
                    // console.log(res.data.data)
                    for (var i=0;i<res.data.data.length;i++){
                        this.list[i].name=res.data.data[i].classname
                        this.list[i].id=res.data.data[i].id
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
.mpro{
    width:100%;
    .title{
        width:140px;
        height:130px;
        background:rgba(51,49,55,1);
        text-align: center;
        line-height: 130px;
        color:white;
        margin: 0 auto;
        font-family: "SourceHanSerifCN-Medium";
        cursor: pointer;
    }
    .allItems{
        width:1440px;
        margin: 60px auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        .item{
            width:30%;
            margin-left: 1%;
            background:rgba(255,255,255,1);
            box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            position: relative;
            padding:50px 0;
            margin-top:30px;
            cursor: pointer;
            .one{
                position: absolute;
                width:100%;
                transition: all 600ms;
                top:90px;
                left:0;
                display: flex;
               flex-direction: column;
                align-items: center;
                p{
                    font-family: "SourceHanSerifCN-Medium";
                    margin-top: 20px;
                    font-size: 14px;
                }
            }
            .two{
                width:100%;
                text-align: center;
                transition: all 600ms;
                transform: scale(0);
                p{
                    font-size: 14px;
                    font-family: "SourceHanSerifCN-Medium";
                }
            }
            &:hover{
                .one{
                    transform: scale(0);
                }
                .two{
                    transform: scale(1);
                }
            }
        }
        .item:nth-child(5){
            .one{
                transform: scale(0);
            }
            .two{
                transform: scale(1);
                img{
                    margin-top:10px;
                }
            }
            &:hover{
                .one{
                    transform: scale(1);
                }
                .two{
                    transform: scale(0);
                }
            }
        }
        .item:nth-child(7){
            .two{
                img{
                    margin-top: 70px;
                }
            }
        }
    }
    @media screen and (max-width: 1440px){
        .allItems{
            width:90%;
        }
    }
    @media screen and (max-width: 1000px){
        .title{
            width:100px;
            height:90px;
            line-height: 90px;
        }
     .allItems{
         flex-direction: column;
         .item{
             width:100%;
             margin-left: 0;
         }
     }
    }
}
</style>
